import { useApi } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useRecent } from "../lib/store";
import PropertyCard from "./PropertyCard";

export default function RecentlyViewed({ excludeId }) {
  const { t } = useI18n();
  const ids = useRecent().filter((id) => id !== excludeId);
  const { data } = useApi(ids.length ? `/properties/by-ids?ids=${ids.join(",")}` : null);
  if (!ids.length || !data?.length) return null;
  const ordered = ids.map((id) => data.find((p) => p.id === id)).filter(Boolean);
  return (
    <section data-testid="recently-viewed-strip" className="container-lux py-16">
      <h2 className="h-display mb-8 text-2xl md:text-3xl">{t("listing.recent")}</h2>
      <div className="-mx-5 flex snap-x gap-5 overflow-x-auto px-5 pb-4">
        {ordered.map((p) => (<div key={p.id} className="w-[300px] shrink-0 snap-start"><PropertyCard p={p} /></div>))}
      </div>
    </section>
  );
}
